import { uk as reactuk } from '@ews/react-translations';

const uk = {
...reactuk
}
export default uk
